<template>
<div class="chapter">
<div class="inner_page">
<p class="ct">Contents</p>
<p class="toc" id="fm06"><a href="#/frontmatter06">Prologue</a></p>
<p class="toc" id="ch01"><a href="#/chapter01">1 Games with Boys</a></p>
<p class="toc" id="ch02"><a href="#/chapter02">2 Me &amp; My Magical Friends</a></p>
<p class="toc" id="ch03"><a href="#/chapter03">3 Driver’s Ed</a></p>
<p class="toc" id="ch04"><span href="#/chapter04" title="Link target outside of Sample">4 The Date</span></p>
<p class="toc" id="ch05"><span href="#/chapter05" title="Link target outside of Sample">5 Fight or Flight</span></p>
<p class="toc" id="ch06"><span href="#/chapter06" title="Link target outside of Sample">6 Bad, Brewing Things</span></p>
<p class="toc" id="ch07"><span href="#/chapter07" title="Link target outside of Sample">7 12 uNDER</span></p>
<p class="toc" id="ch08"><span href="#/chapter08" title="Link target outside of Sample">8 King of the Kids</span></p>
<p class="toc" id="ch09"><span href="#/chapter09" title="Link target outside of Sample">9 Carrier Griffin</span></p>
<p class="toc1" id="ch10"><span href="#/chapter10" title="Link target outside of Sample">10 My Best Friend the Entrepreneur</span></p>
<p class="toc1" id="ch11"><span href="#/chapter11" title="Link target outside of Sample">11 Boy Friends</span></p>
<p class="toc1" id="ch12"><span href="#/chapter12" title="Link target outside of Sample">12 Trial &amp; Error</span></p>
<p class="toc1" id="ch13"><span href="#/chapter13" title="Link target outside of Sample">13 Patents</span></p>
<p class="toc1" id="ch14"><span href="#/chapter14" title="Link target outside of Sample">14 Ball Interrupted</span></p>
<p class="toc1" id="ch15"><span href="#/chapter15" title="Link target outside of Sample">15 The New Captain in Town</span></p>
<p class="toc1" id="ch16"><span href="#/chapter16" title="Link target outside of Sample">16 Thirty-Eight</span></p>
<p class="toc1" id="ch17"><span href="#/chapter17" title="Link target outside of Sample">17 Endings &amp; Beginnings</span></p>
<p class="toc1" id="ch18"><span href="#/chapter18" title="Link target outside of Sample">18 Meet the Darlings</span></p>
<p class="toc1" id="ch19"><span href="#/chapter19" title="Link target outside of Sample">19 Mark</span></p>
<p class="toc1" id="ch20"><span href="#/chapter20" title="Link target outside of Sample">20 FGWs</span></p>
<p class="toc1" id="ch21"><span href="#/chapter21" title="Link target outside of Sample">21 Mr. Sandman</span></p>
<p class="toc1" id="ch22"><span href="#/chapter22" title="Link target outside of Sample">22 Stella</span></p>
<p class="toc1" id="ch23"><span href="#/chapter23" title="Link target outside of Sample">23 Harbinger of Death</span></p>
<p class="toc1" id="ch24"><span href="#/chapter24" title="Link target outside of Sample">24 Rebels with a New Cause</span></p>
<p class="toc1" id="ch25"><span href="#/chapter25" title="Link target outside of Sample">25 Change</span></p>
<p class="toc1" id="ch26"><span href="#/chapter26" title="Link target outside of Sample">26 Goodbyes</span></p>
<p class="toc1" id="ch27"><span href="#/chapter27" title="Link target outside of Sample">27 Enigma</span></p>
<p class="toc1" id="ch28"><span href="#/chapter28" title="Link target outside of Sample">28 The Hypotheticals</span></p>
<p class="toc1" id="ch29"><span href="#/chapter29" title="Link target outside of Sample">29 Wanderers</span></p>
<p class="toc1" id="ch30"><span href="#/chapter30" title="Link target outside of Sample">30 Nightmare</span></p>
<p class="toc1" id="ch31"><span href="#/chapter31" title="Link target outside of Sample">31 Queen’s Gambit</span></p>
<p class="toc1" id="bm02"><span href="#/backmatter02" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cd5b544e